var GuideSingleMultiPicker = {
    me: this,
    selectedJurisdictionList: [],
    selectedRegionList: [],
    selectedQuestionList: [],
    jurisdictionQuickLookup: [],
    questionsQuickLookup: [],
    jurisdictionCheckboxList: [],
    guideErrorMessages: null,

    guideBuildLoading: null,
    guideBuildDisplay: null,
    jurisdictionsPopulated: false,
    questionsPopulated: false,

    Init: function () {
        console.log('Init GuideSingleMultiPicker')
        this.guideErrorMessages = document.querySelector('.guideErrorMessages');
        this.guideBuildLoading = document.getElementById('IGResultsLoading');
        this.guideBuildDisplay = document.getElementById('IGResults');
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('questions') != null) {
            var q = queryParams.get('questions').split(",");
            this.selectedQuestionList = q;
            if (this.selectedQuestionList.length > 0) {
                this.questionsPopulated = true;
            }
            q.forEach(function (el) {
                var checkbox = document.getElementById("GQ_" + el);
                checkbox.checked = true;
            }.bind(this));
        }
        jurisdictionCheckboxList = document.querySelectorAll('#jurisdictionCheckboxes input[type=checkbox]:not(.jurisdictionSelectAll)');
        jurisdictionCheckboxList.forEach((val, index) => {
            this.jurisdictionQuickLookup.push({ id: parseInt(val.getAttribute('id')), element: val });
        });
        if (queryParams.get('jurisdictions') != null) {
            var temp = queryParams.get('jurisdictions').replaceAll(", ", "*");
            var j = temp.split(",");
            /*       console.log("J: %o Query params: %o", j, temp);*/
            j.forEach(function (el) {
                var val = el.replaceAll("*", ", ");
                var jArray = val.split("-");
                /*    console.log("JArray: %o", jArray);*/
                var checkbox = document.getElementById(jArray[1]);

                checkbox.checked = true;
                /* console.log("Checkbox: %o", checkbox);*/
                this.addJurisdictionToSelectedList(jArray[0], jArray[1]);
                // Find each checkbox and set checked to true
                this.renderJurisdictionList();
            }.bind(this));
            if (this.selectedJurisdictionList.length > 0) {
                this.jurisdictionsPopulated = true;
            }
        }
        if (queryParams.get('stage') != null) {
            if (queryParams.get('stage') == "questions") {
                var checkboxes = document.querySelectorAll('#questionsContainer input[type=checkbox]');
                var checked = true;
                checkboxes.forEach(function (el) {
                    /*    console.log("EL: %o", el.checked);*/
                    if (el.checked == false) {
                        checked = false;
                    }
                });
                document.getElementById("selectAllQuestions").checked = checked;

                this.switchStage(2);
                var breadcrumb = document.querySelector(".breadcrumb");
                var last = breadcrumb.lastElementChild;
                breadcrumb.removeChild(breadcrumb.children[2]);
                console.log("Breadcrumb : %o", last);
                var newA = document.createElement('a');
                newA.classList.add("breadcrumb__link");
                newA.setAttribute('href', "/resources/guides-toolkits/global-practice-guides/");
                newA.innerHTML = "Global practice guides";

                breadcrumb.appendChild(newA);
                breadcrumb.appendChild(last);
            }
            else if (queryParams.get('stage') == "report") {
                //var json = {
                //    'topic': guideTitle,
                //    'jurisdictions': commaEncodeForJson(this.selectedJurisdictionList),
                //    'questions': commaEncodeQuestions(this.selectedQuestionList, true),
                //    'regions': this.commaEncodedRegions(),

                //};

                //console.log("Json object: %o", JSON.stringify(json));
                this.buildFilters();
                // Go to stage 3
                this.switchStage(3);
                this.getTableListing();
            }
        }
        if (this.jurisdictionsPopulated && this.questionsPopulated) {
            // Go straight to guide page
        }

        console.log("Jurisdictions: %o, Questions: %o", queryParams.get('jurisdictions'), queryParams.get('questions'))
        let checkBoxGroups = document.querySelectorAll('.singleMultiSwitcher .parentItem');
        let singleMultiItems = document.querySelectorAll('.singleMultiSwitcher .tab a');
        let stage1QuestionNext = document.getElementById('stage1QuestionNext');
        let stage1QuestionNextBottom = document.getElementById('stage1QuestionNextBottom');
        let stage2QuestionNext = document.getElementById('stage2QuestionNext');
        let stage2QuestionBack = document.getElementById('stage2QuestionBack');
        let stage3QuestionBack = document.getElementById('stage3QuestionBack');
        let JurisdictionDropDown = document.getElementById('guideJurisdiction');
        let showAllJurisdictions = document.getElementById('showAllJurisdictions');
        let showAllStage3 = document.getElementById('stage3ShowAll');
        let stage3ApplyFilters = document.getElementById('stage3ApplyFilters');
        let jurisdictionCheckboxes = document.getElementById('jurisdictionCheckboxes');
        let jurisdictionCheckbox = document.querySelectorAll('.jurisdiction-checkbox');
        let reportCheckbox = document.querySelectorAll('.report-checkbox');
        let JurisdictionQuestionNext = document.getElementById('JurisdictionQuestionNext');
        let selectAllQuestions = document.getElementById('selectAllQuestionsLabel');
        let selectAllJurisdictions = document.getElementById('selectAllJurisdictionsLabel');
        let selectAllJurisdictionsInGroup = document.querySelectorAll('.jurisdictionSelectAllInGroup');
        let questionCheckboxes = document.querySelectorAll('#questionsContainer .guides__checkbox-label');
        let mobileJursdictionDropdown = document.getElementById('mobileJurisdictionSelecter')

        var url = window.location.href;
        var queryParams = new URLSearchParams(window.location.search);

        var urlKeywords, urlJurisdictions, urlQuestions;
        urlKeywords = urlJurisdictions = urlQuestions = '';
        console.log("DROPDOWN VALUE: %o", document.getElementById("mobileJurisdictionSelecter").options[0]);

        //   document.getElementById("mobileGuideNext").setAttribute("href", document.getElementById('mobileJurisdictionSelecter').value);
        /*      console.log("Url: %o, Query params: %o", url, queryParams);*/
        // Switch between single and multi
        singleMultiItems.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                let toTab = el.classList.length > 0 ? el.classList[0] : '';
                //console.log('Switch tab : ' + toTab);

                let wrapper = el.closest('.singleMultiSwitcher');

                // Tab title
                let activeTab = el.closest('.tab');
                wrapper.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });    // Make all tabs inactive
                //console.log(wrapper.querySelectorAll('.tab'));
                activeTab.classList.add('active');                   // Make clicked tab active

                // Tab Content
                wrapper.querySelectorAll('.tabContent').forEach(function (tc) { tc.classList.add('hidden');; });   // Hide all content tabs
                let className = '.tabContent.' + toTab.replace(' active', '');
                let contentDiv = wrapper.querySelector(className);              // Show clicked content
                contentDiv.classList.remove('hidden');
            }.bind(this));
        }.bind(this));
        //document.getElementById('guideBack').addEventListener('click', function (e) {
        //    e.preventDefault();
        //    history.back();
        //});
        questionCheckboxes.forEach(function (el) {
            el.addEventListener('click', function (e) {
                var c = el.previousElementSibling;
                /*    console.log("prev sibling: %o", c);*/
                this.addQuestionToSelectedList(c.value);
            }.bind(this));
        }.bind(this));

        // Top level checkbox group - Select / unselect all
        checkBoxGroups.forEach(function (el) {
            el.addEventListener('click', function (e) {
                let childChecks = e.target.closest('li').querySelectorAll('ul li div.checkbox-container input');
                let checkall = e.target.checked;
                childChecks.forEach(function (el) {
                    if (checkall) {
                        el.checked = true;
                    } else {
                        el.checked = false;
                    }
                });
            }.bind(this));
        }.bind(this));

        // Next button on stage 1 - Questions
        stage1QuestionNext.addEventListener('click', function (e) {
            let childChecks = document.querySelectorAll('#jurisdictionList div');  // Only check nested

            //console.log(childChecks);
            if (childChecks.length > 0) {
                var params = new URLSearchParams(window.location.search);
                params.set('stage', "questions");
                var sparam = '' + params;
                if (sparam !== '') {
                    window.history.replaceState({}, '', window.location.pathname + '?' + params);
                } else {
                    window.history.replaceState({}, '', window.location.pathname);
                }

                this.switchStage(2);
                scrollToAnchorIDVanilla('topOfQuestionCheckboxes');
            } else {
                // Anchor to top and show error message
                this.showErrorMessage('Please select at least one jurisdiction');
            }
        }.bind(this));
        stage1QuestionNextBottom.addEventListener('click', function (e) {
            let childChecks = document.querySelectorAll('#jurisdictionList div'); // Only check nested
            //console.log(childChecks);
            if (childChecks.length > 0) {
                this.switchStage(2);
                scrollToAnchorIDVanilla('topOfQuestionCheckboxes');
            } else {
                // Anchor to top and show error message
                this.showErrorMessage('Please select at least one jurisdiction');
            }
        }.bind(this));
        stage2QuestionNext.addEventListener('click', function (e) {
            let childChecks = document.querySelectorAll('#questionsContainer input[type=checkbox]:checked');
            //console.log('Checked questions : %o', childChecks);
            //   this.selectedQuestionList = [];  // clear it out
            if (childChecks.length > 0) {
                // Save the checked items
                //childChecks.forEach((c) => {
                //    this.selectedQuestionList.push(parseInt(c.value));
                //});
                var params = new URLSearchParams(window.location.search);
                params.set('stage', "report");
                var sparam = '' + params;
                if (sparam !== '') {
                    window.history.replaceState({}, '', window.location.pathname + '?' + params);
                } else {
                    window.history.replaceState({}, '', window.location.pathname);
                }
                const currentUrl = new URL(window.location);
                window.history.pushState({}, '', currentUrl);
                window.addEventListener('popstate', function (event) {
                    event.preventDefault();
                    var params = new URLSearchParams(window.location.search);
                    params.set('stage', "questions");
                    var sparam = '' + params;
                    if (sparam !== '') {
                        window.history.replaceState({}, '', window.location.pathname + '?' + params);
                    } else {
                        window.history.replaceState({}, '', window.location.pathname);
                    }

                    if (event.state != null) {
                        location.reload();
                    }
                });
                //const currentUrl = new URL(window.location);
                //window.history.pushState({}, '', currentUrl);
                //addEventListener('popstate', () => { location.reload() });

                // Create Json String
                var json = {
                    'topic': guideTitle,
                    'jurisdictions': commaEncodeForJson(this.selectedJurisdictionList),
                    'questions': commaEncodeQuestions(this.selectedQuestionList, true),
                    'regions': this.commaEncodedRegions(),
                    //  'questions': ["What is the key anti-bribery and corruption legislation in your jurisdiction", "Who is subject to the legislation?"," Is requesting or accepting a bribe prohibited by the legislation?"] ,
                };

                console.log("Json object: %o", JSON.stringify(json));
                this.buildFilters();
                // Go to stage 3
                this.switchStage(3);
                this.getTableListing();
            } else {
                // Anchor to top and show error message
                this.showErrorMessage('Please select at least one question');
            }
        }.bind(this));

        stage3ApplyFilters.addEventListener('click', function (e) {
            if (this.selectedQuestionList.length > 0) {
                // Hide jurisdiction list if visible
                jurisdictionCheckboxes.classList.add("hidden");
                // Go to stage 3
                this.switchStage(3);
                scrollToAnchorIDVanilla('topOfIGResults');
                this.getTableListing();
            } else {
                alert('Lost track of questions');
            }
        }.bind(this));

        stage2QuestionBack.addEventListener('click', function (e) {
            var params = new URLSearchParams(window.location.search);

            params.delete('stage');

            var sparam = '' + params;
            if (sparam !== '') {
                window.history.replaceState({}, '', window.location.pathname + '?' + params);
            } else {
                window.history.replaceState({}, '', window.location.pathname);
            }
            this.switchStage(1);
        }.bind(this));

        stage3QuestionBack.addEventListener('click', function (e) {
            this.switchStage(2);
        }.bind(this));

        showAllJurisdictions.addEventListener('click', function (e) {
            if (jurisdictionCheckboxes.classList.contains("hidden")) {
                jurisdictionCheckboxes.classList.remove("hidden");
                showAllJurisdictions.value = hideJurisdictionsCaption;  // This is a global var in /blocklist/components/practiceGuideSingleMultiPicker
            }
            else {
                jurisdictionCheckboxes.classList.add("hidden");
                showAllJurisdictions.value = showAllJurisdictionsCaption;  // This is a global var in /blocklist/components/practiceGuideSingleMultiPicker
            }
        }.bind(this));

        showAllStage3.addEventListener('click', function (e) {
            if (jurisdictionCheckboxes.classList.contains("hidden")) {
                jurisdictionCheckboxes.classList.remove("hidden");
                showAllStage3.value = "Hide";
            }
            else {
                jurisdictionCheckboxes.classList.add("hidden");
                showAllStage3.value = "Show all";
            }
        }.bind(this));

        jurisdictionCheckbox.forEach(function (el) {
            el.addEventListener('click', function (e) {
                var elVal = parseInt(el.value);
                var region = el.getAttribute("data-group-title");
                /*   console.log("Region: %o", this.jurisdictionQuickLookup);*/
                if (el.checked == false) {
                    this.removeJurisdictionFromSelectedList(elVal);
                }
                else {
                    this.addJurisdictionToSelectedList(el.name, elVal);
                }
                this.renderJurisdictionList();
            }.bind(this));
        }.bind(this));

        mobileJursdictionDropdown.addEventListener('change', function (e) {
            document.getElementById("mobileGuideNext").setAttribute("href", this.value);
        });

        document.getElementById("mobileGuideNext").addEventListener('click', function (e) {
            if (this.getAttribute("href") == '') {
                e.preventDefault();
            }
        });
        // Remove buttons on the selected jurisdictions
        document.getElementById("jurisdictionList").addEventListener("click", function (e) {
            if (e.target && e.target.parentNode.classList.contains('jurisdiction-item')) {
                // Do something
                //console.log('clicked checkbox with id : %o ', e.target.parentNode.getAttribute('data-id'));
                this.removeJurisdictionFromSelectedList(parseInt(e.target.parentNode.getAttribute('data-id')));
            }
        }.bind(this));

        // Select all / None jurisdiction buttons
        document.querySelectorAll(".guides__checkbox-title .selectAllNone").forEach((ele) => {
            ele.addEventListener("click", function (e) {
                console.log('Clicked select all none');
                //if (e.target && e.target.classList.contains('selectAllNone')) {
                // Kill the click action
                e.preventDefault();

                var targetEle = e.target;

                var targetId = `CBGroup_${targetEle.parentNode.getAttribute('data-group-id')}`;

                let selecting = false;
                if (targetEle.classList.contains('all')) {
                    selecting = true;
                }

                /*      console.log('targetId : %o', targetId);*/
                var targetDivs = document.querySelectorAll('.' + targetId);
                var checkboxes = [];
                targetDivs.forEach((val, index) => {
                    var allCheckboxes = val.querySelectorAll('input[type = checkbox]');
                    allCheckboxes.forEach((checkbox, index) => {
                        checkboxes.push(checkbox);
                    });
                });

                //  var targetDiv = document.getElementById(targetId);
                // var checkboxes = targetDiv.querySelectorAll('input[type = checkbox]');

                let shouldSkip = false;
                checkboxes.forEach((c) => {
                    if (shouldSkip) {
                        return;
                    }
                    var eleName = c.getAttribute('name');
                    var eleID = parseInt(c.getAttribute('id'));

                    //c.checked = selecting;
                    if (!selecting) {
                        this.removeJurisdictionFromSelectedList(eleID, true);
                    }
                    else {
                        //if (this.selectedJurisdictionList.length == 5) {
                        //    alert('Only a maximum of 5 jursidictions can be selected at once.');
                        //    shouldSkip = true;
                        //    return;

                        //}
                        //  else {
                        this.addJurisdictionToSelected(eleName, eleID, true);
                        // }
                    }
                });

                this.renderJurisdictionList();
                //}
            }.bind(this));
        });
        selectAllQuestions.addEventListener('click', function (e) {
            let checkbox = document.getElementById('selectAllQuestions');

            var selecting = false;

            if (checkbox.checked == false) {
                checkbox.checked = true;
                selecting = true;
            }
            else {
                checkbox.checked = false;
            }
            var checkboxes = this.questionsQuickLookup;

            checkboxes.forEach((c) => {
                c.element.checked = selecting;
                if (selecting) {
                    this.addQuestionToSelectedList(c.element.value);
                }
                else {
                    this.removeQuestionFromSelectedList(c.element.value);
                }
            });
            if (!selecting) {
                this.selectedQuestionList = [];
                this.buildFilters();
            }
        }.bind(this));

        selectAllJurisdictions.addEventListener('click', function (e) {
            let checkbox = document.getElementById('selectAllJurisdictions');

            var selecting = false;

            if (checkbox.checked == false) {
                //checkbox.checked = true;
                selecting = true;
            }
            else {
                //checkbox.checked = false;
            }
            var checkboxes = this.jurisdictionQuickLookup;

            checkboxes.forEach((c) => {
                c.element.checked = selecting;
                if (selecting) {
                    this.addJurisdictionToSelectedList(c.element.name, c.element.value);

                    selectAllJurisdictionsInGroup.forEach(function (selectAllBox) {
                        selectAllBox.checked = true;
                    });
                }
                else {
                    this.removeJurisdictionFromSelectedList(c.element.value);

                    selectAllJurisdictionsInGroup.forEach(function (selectAllBox) {
                        selectAllBox.checked = false;
                    });
                }
            });
            if (!selecting) {
                this.selectedJurisdictionList = [];
                this.buildFilters();
            }

            this.renderJurisdictionList();
        }.bind(this));

        selectAllJurisdictionsInGroup.forEach(function (selectAllBox) {
            selectAllBox.addEventListener('click', function (e) {

                var selecting = false;

                if (selectAllBox.checked == true) {
                    //checkbox.checked = true;
                    selecting = true;
                }

                var selectAllBoxVal = parseInt(selectAllBox.value);
                var selector = ".CBGroup_" + selectAllBoxVal;
                var groupContainers = document.querySelectorAll(selector);

                //The checkboxes might be split across multiple groups in different columns, so we need to collate them
                var checkboxes = [];
                groupContainers.forEach((group) => {
                    var boxes = group.querySelectorAll('.jurisdiction-checkbox');
                    boxes.forEach((box) => {
                        checkboxes.push(box);
                    });
                });

                checkboxes.forEach((c) => {
                    c.checked = selecting;
                    if (selecting) {
                        this.addJurisdictionToSelectedList(c.name, c.value);
                    }
                    else {
                        this.removeJurisdictionFromSelectedList(c.value);
                    }
                });

                if (selecting) {
                    this.buildFilters();
                }

                this.renderJurisdictionList();

                if (selecting) {
                    scrollToAnchorIDVanilla("autoCompleteStage1");
                }

            }.bind(this));
        }.bind(this));

        document.querySelectorAll("a.guides__question-list-group").forEach((ele) => {
            ele.addEventListener("click", function (e) {
                var groupId = e.target.getAttribute('data-group-id');
                console.log(groupId);

                document.querySelectorAll(`input[data-group-id="${groupId}"]`).forEach((questionEle) => {
                    var questionId = questionEle.value;

                    if (questionEle.checked) {
                        questionEle.checked = false;
                        this.removeQuestionFromSelectedList(questionId);
                    }
                    else {
                        questionEle.checked = true;
                        this.addQuestionToSelectedList(questionId);
                    }
                });
            }.bind(this));
        });

        // Select all / None question buttons
        document.querySelectorAll("#questionsContainer .selectAllNoneQuestions").forEach((ele) => {
            ele.addEventListener("click", function (e) {
                console.log('Clicked select all none question');

                e.preventDefault();

                let selecting = false;
                if (e.currentTarget.classList.contains('all')) {
                    selecting = true;
                }

                var checkboxes = this.questionsQuickLookup;

                checkboxes.forEach((c) => {
                    c.element.checked = selecting;
                });
            }.bind(this));
        });

        // Jurisdiction quick lookup
        jurisdictionCheckboxList = document.querySelectorAll('#jurisdictionCheckboxes input[type=checkbox]:not(.jurisdictionSelectAll)');
        jurisdictionCheckboxList.forEach((val, index) => {
            this.jurisdictionQuickLookup.push({ id: parseInt(val.getAttribute('id')), element: val });
        });
        // Question quick lookup
        let questionCheckboxList = document.querySelectorAll('#questionsContainer input[type=checkbox]');

        questionCheckboxList.forEach((val, index) => {
            this.questionsQuickLookup.push({ id: parseInt(val.getAttribute('id')), element: val });
        });
        console.log(questionCheckboxList);

        // Title
        // document.getElementById('guide--title').innerHTML = guideTitle;

        // Debug
        //this.selectedJurisdictionList.push({ id: 42254, caption: 'Canada, Ontario' });
        //this.selectedJurisdictionList.push({ id: 42265, caption: 'Canda, Quebec' });
        //console.log('this.selectedJurisdictionList : %o ', this.selectedJurisdictionList);
        //this.renderJurisdictionList();
    },   // Init

    showErrorMessage: function (message) {
        this.guideErrorMessages.innerHTML = message;
        this.guideErrorMessages.classList.remove('hidden');
        scrollToAnchorIDVanilla('guideErrorMessages');
    },
    clearErrorMessage: function () {
        this.guideErrorMessages.classList.add('hidden');
        this.guideErrorMessages.innerHTML = '';
    },

    removeJurisdictionFromSelectedList: function (id, suppressRefresh = false) {
        //alert("Removed");
        var newList = this.selectedJurisdictionList;
        /*    console.log("NEw list: %o, Id: %o", newList, id);*/
        this.selectedJurisdictionList.forEach((val, index) => {
            if (val.id == id) {
                // Remove from the checkbox list
                let found = newList.find(o => o.id == id);
                found.clicked = false;

                // Remove from the array
                newList.splice(index, 1);
            }
        });

        this.selectedJurisdictionList = newList;
        if (!suppressRefresh) {
            this.renderJurisdictionList();
        }
        this.buildFilters();
    },
    buildFilters: function () {
        //console.log(' In filters : %o', filterObj.city.join());
        var params = new URLSearchParams(window.location.search);
        console.log("J: %o", this.selectedJurisdictionList);
        this.selectedJurisdictionList.length > 0 ? params.set('jurisdictions', commaEncodeList(this.selectedJurisdictionList, false).join()) : params.delete('jurisdictions');
        this.selectedQuestionList.length > 0 ? params.set('questions', commaEncodeList(this.selectedQuestionList, true).join()) : params.delete('questions');

        var sparam = '' + params;
        if (sparam !== '') {
            window.history.replaceState({}, '', window.location.pathname + '?' + params);
        } else {
            window.history.replaceState({}, '', window.location.pathname);
        }
    },
    addJurisdictionToSelectedList: function (caption, id, isAutoComplete = false) {
        // Already in the list?
        for (let item of this.selectedJurisdictionList) {
            //if (this.selectedJurisdictionList.length == 5) {
            //    alert('Only a maximum of 5 jursidictions can be selected at once.');
            //    return false;

            //}
            if (item.id == id) {
                if (isAutoComplete) {   // Auto complete searched for existing result
                    if (confirm('This items has already been added. Do you want to remove it?')) {
                        this.removeJurisdictionFromSelectedList(id);
                    }
                }
                this.buildFilters();
                return false;
            }
        }

        // Not got this one
        this.selectedJurisdictionList.push({ id: id, caption: caption });
        this.buildFilters();

        return true;
    },
    addQuestionToSelectedList: function (id) {
        console.log("Question id: %o", id);
        // Already in the list?
        for (let item of this.selectedQuestionList) {
            if (item == id) {
                this.removeQuestionFromSelectedList(id);

                this.buildFilters();
                return false;
            }
        }

        // Not got this one
        this.selectedQuestionList.push(id);
        console.log("Selected Question list: %o", this.selectedQuestionList);
        this.buildFilters();
        return true;
    },
    removeQuestionFromSelectedList: function (id, suppressRefresh = false) {
        //alert("Removed");
        var newList = this.selectedQuestionList;

        this.selectedQuestionList.forEach((val, index) => {
            if (val == id) {
                // Remove from the checkbox list
                let found = newList.find(o => o === id);
                found.clicked = false;

                // Remove from the array
                newList.splice(index, 1);
            }
        });
        console.log("New list: %o", newList);
        this.selectedQuestionList = newList;

        this.buildFilters();
    },
    renderJurisdictionList: function () {
        console.log('Render list with : %o', this.selectedJurisdictionList);
        var globalThis = this;

        // Clear everything out
        document.getElementById('jurisdictionList').innerHTML = '';
        jurisdictionCheckboxList.forEach((v) => {
            v.checked = false;
        })

        // Re-apply all
        this.selectedJurisdictionList.forEach((val, index) => {
            // Top templates
            let id = val.id;
            let caption = val.caption;
            let template = `<div class='selected guides__jurisdiction-item flex flex--justify flex--center flex--gap--small' data-id='${id}' data-caption='${caption}'> ${caption}<i class='icon icon--close guides__remove-jurisdiction cursor--pointer'></i></div>`;     // onclick='removeJurisdictionFromSelected("${caption}",${id});'
            document.getElementById('jurisdictionList').innerHTML += template;
            let removeIcons = document.querySelectorAll('.guides__remove-jurisdiction');
            removeIcons.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    let parent = el.parentNode;
                    globalThis.removeJurisdictionFromSelectedList(parseInt(parent.getAttribute('data-id')));
                });
            });
            // Check the boxes
            let found = this.jurisdictionQuickLookup.find(o => o.id == id);
            if (found !== undefined && found !== null) {
                found.element.checked = true;
            } else {
                console.warn('Jurisdiction checkbox missing for id : %o', id);
            }
        });
    },

    addJurisdictionToSelected: function (caption, id, suppressRefresh = false) {
        let added = this.addJurisdictionToSelectedList(caption, id);
        //console.log('Selected jurisdictions : %o', this.selectedJurisdictionList);
        if (!suppressRefresh) {
            this.renderJurisdictionList();
        }
    },

    getTableListing: function () {
        this.guideBuildLoading.classList.remove('hidden');
        let questionChecks = document.querySelectorAll('#questionsContainer ul li input:checked');
        // let body = document.querySelector('body');

        var qIDs = this.selectedQuestionList;
        //questionChecks.forEach((v) => qIDs.push(parseInt(v.value)));

        var jIDs = [];
        this.selectedJurisdictionList.forEach((v) => jIDs.push(v.id));

        // DEBUG
        //jIDs = ['34885','34886'];
        //qIDs = ['35126','35138'];  //, '35114', '35102', '35090', '35078', '35066', '35054', '35042', '35030', '35018', '35006', '34994', '34982', '34970', '34958', '34946', '34934', '34922', '34910'

        console.log('Q : %o , J : %o', qIDs, jIDs);

        var prom = this.getSearchResultsQuery(qIDs, jIDs);
        prom.then(
            function (result) {
                var guideTitle = document.getElementById('guide--title').innerHTML;
                //console.log("Search results : %o", result);
                setTimeout(() => {
                    this.guideBuildLoading.classList.add('hidden');
                }, 1000);
                this.guideBuildDisplay.classList.remove('hidden');
                body.classList.add('overflow--hidden');
                document.getElementById('IGResults').innerHTML = result; //result.htmlResults;
                document.getElementById('guide--title--overlay').innerHTML = guideTitle;
                calculateHeight();
                applyClicks();

                var anchors = document.getElementById('reportBody').getElementsByTagName('a');
                for (var i = 0; i < anchors.length; i++) {
                    anchors[i].setAttribute('target', '_blank');
                }
                document.querySelectorAll('.report-checkbox').forEach(function (el) {
                    el.checked = true;
                    el.addEventListener('click', function (e) {
                        //      console.log("IS CHECKED: %o", document.querySelectorAll('.report-checkbox-container input[type=checkbox]:checked'));
                        var checked = document.querySelectorAll('.report-checkbox-container input[type=checkbox]:checked');
                        if (checked.length == 0) {
                            document.getElementById('reportBody').classList.add("hidden");
                        }
                        else {
                            document.getElementById('reportBody').classList.remove("hidden");
                        }

                        var reportInfo = document.querySelectorAll('.info-' + el.id);
                        /*  console.log("report info: %o", reportInfo);*/

                        reportInfo.forEach(function (element) {
                            if (element.classList.contains("hidden")) {
                                element.classList.remove("hidden");
                            }
                            else {
                                element.classList.add("hidden");
                            }
                        });
                    }.bind(this));
                }.bind(this));
                document.getElementById('tableClose').addEventListener('click', function (e) {
                    e.preventDefault();
                    const currentUrl = new URL(window.location);
                    window.history.pushState({}, '', currentUrl);

                    var params = new URLSearchParams(window.location.search);
                    params.set('stage', "questions");
                    var sparam = '' + params;
                    if (sparam !== '') {
                        window.history.replaceState({}, '', window.location.pathname + '?' + params);
                    } else {
                        window.history.replaceState({}, '', window.location.pathname);
                    }
                    location.reload();
                });
            }.bind(this)
        )
    },

    commaEncodedRegions: function () {
        var encoded = [];
        for (i = 0; i < this.selectedJurisdictionList.length; i++) {
            let found = this.jurisdictionQuickLookup.find(o => o.id == this.selectedJurisdictionList[i].id);
            var region = found.element.getAttribute("data-group-title");
            /*    console.log("FOUND: %o", found);*/
            if (!encoded.includes(region)) {
                encoded.push(region);
            }
        }

        return encoded;
    },

    switchStage: function (toStage) {
        var container = document.getElementById("showAllContainer");
        if (toStage == 2) {
            jurisdictionCheckboxes.classList.add("hidden");
            document.getElementById("jurisdictionList").classList.add("hidden");
            showAllJurisdictions.value = showAllJurisdictionsCaption;  // This is a global var in /blocklist/components/practiceGuideSingleMultiPicker

            // Move the auto complete
            var autoCompleteElement = document.getElementById('autoComplete');
            var stage3Holder = document.getElementById('autoCompleteStage3');
            stage3Holder.appendChild(autoCompleteElement);
            console.log('apply js autocomplete');
            autoCompleteJS = new autoComplete(autoCompleteConfig);
        }
        if (toStage == 1) {
            // Move the auto complete
            document.getElementById("jurisdictionList").classList.remove("hidden");
            var autoCompleteElement = document.getElementById('autoComplete');
            var stage1Holder = document.getElementById('autoCompleteStage1');
            stage1Holder.appendChild(autoCompleteElement);
            console.log('apply js autocomplete');
            autoCompleteJS = new autoComplete(autoCompleteConfig);
        }

        document.querySelectorAll('.qStages').forEach(function (el) {
            el.classList.add('hidden');
        });

        // Clear out any errors
        this.clearErrorMessage();

        document.querySelector('.qStages.stage' + toStage).classList.remove('hidden');
    },

    getSearchResultsQuery: function (qIDs, jIDs) {
        return new Promise(function (resolve, reject) {
            searchParams = { jurisdictions: jIDs, questions: qIDs }
            console.log('GetSearchResults from searchParams : %o', searchParams);

            fetch('/Umbraco/Surface/InteractiveGuidesFrontEnd/GetGuides', {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());

                    resolve(response.text());
                })
                .catch(error => {
                    //console.log('Failed', error);
                    reject(error);
                });
        });
    }
}

function tableClose(e) {
    const table = e.parentNode.parentNode;

    table.classList.add('hidden')
    body.classList.remove('overflow--hidden')
}
function commaEncode(value) {
    //   if (FacHelpers.isNullOrEmpty(value)) {
    //      return '';
    //  } else {
    /*    console.log("val: %o", value);*/
    if (typeof value === 'string') {
        return value.replace(',', '--');
    } else {
        return value;
    }
    //}
}
function commaEncodeForJson(valueA) {
    var encoded = [];
    for (i = 0; i < valueA.length; i++) {
        encoded.push(valueA[i].caption);
    }

    return encoded;
}
function commaEncodedRegions() {
    var encoded = [];
    for (i = 0; i < selectedJurisdictionList.length; i++) {
        let found = this.jurisdictionQuickLookup.find(o => o.id == selectedJurisdictionList[i].id);
        var region = "";
        /*        console.log("FOUND: %o", found);*/
        if (!encoded.contains(region)) {
            encoded.push(region);
        }
    }

    return encoded;
}
function commaEncodeQuestions(valueA) {
    /*   console.log("List: %o", valueA);*/
    var encoded = [];
    for (i = 0; i < valueA.length; i++) {
        var c = document.getElementById("GQ_" + valueA[i]);
        var id = "GQ_" + valueA[i];
        var label = document.querySelectorAll('[for="' + id + '"]');

        /*  console.log("Label: %o", label[0].innerHTML);*/
        encoded.push(label[0].innerHTML);
    }

    return encoded;
}
function commaEncodeList(valueA, isQuestions) {
    console.log("List: %o", valueA);
    var encoded = [];
    for (i = 0; i < valueA.length; i++) {
        if (isQuestions) {
            encoded.push(valueA[i]);
        }
        else {
            encoded.push(valueA[i].caption + "-" + valueA[i].id);
        }
    }

    return encoded;
}
function commaDecode(value) {
    //if (FacHelpers.isNullOrEmpty(value)) {
    //     return '';
    //} else {
    if (typeof value === 'string') {
        return value.replace('--', ',');
    } else {
        return value;
    }
    //}
}
function commaDecodeList(valueA) {
    var decoded = [];
    for (i = 0; i < valueA.length; i++) {
        decoded.push(commaDecode(valueA[i]));
    }
    return decoded;
}
window.onload = function (e) {
    document.getElementById("mobileGuideNext").setAttribute("href", document.getElementById("mobileJurisdictionSelecter").value);
}